var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15693",
    "data-name": "Group 15693",
    transform: "translate(-856 -698)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2041",
    "data-name": "Rectangle 2041",
    width: 25,
    height: 25,
    transform: "translate(856 698)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(-4559.777 71.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(5416.777 628.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M5439.509,633.311a6.136,6.136,0,0,0-2.8-4.191,6.369,6.369,0,0,0-5.083-.7,7.255,7.255,0,0,0-3.408,2.24c-.047-.047-.1-.094-.148-.142-.3-.289-.611-.6-.94-.869a6.51,6.51,0,0,0-5.13-1.386,6.13,6.13,0,0,0-4.238,2.8,6.661,6.661,0,0,0-.54,5.922,10.333,10.333,0,0,0,2.366,3.713,65.772,65.772,0,0,0,6.611,5.969c.588.486,1.175.972,1.755,1.457l.259.212.736-.619c.6-.509,1.19-1.019,1.793-1.528,1.386-1.175,2.82-2.389,4.205-3.619a18.213,18.213,0,0,0,3.376-3.791A7.432,7.432,0,0,0,5439.509,633.311Zm-1.9,1.88a7.475,7.475,0,0,1-2,3.908,41.308,41.308,0,0,1-4.52,4.278q-1,.858-2.021,1.691l-.893.745-1.34-1.152c-1.238-1.058-2.506-2.147-3.736-3.251a35.1,35.1,0,0,1-2.593-2.678,6.807,6.807,0,0,1-1.645-3.18,4.315,4.315,0,0,1,2.663-5.131,4.9,4.9,0,0,1,1.591-.289,4.56,4.56,0,0,1,3.188,1.4c.376.369.729.752,1.1,1.167.165.188.345.376.518.572l.337.25.43-.461c.2-.2.384-.408.572-.611a12.478,12.478,0,0,1,1.246-1.253,4.314,4.314,0,0,1,5.467-.173A4.255,4.255,0,0,1,5437.606,635.191Z",
    transform: "translate(-5416.776 -628.181)",
    fill: "#3f2566"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavPurple);
export default __webpack_public_path__ + "static/media/fav-purple.c96ac3fc2184b53ca2d96e476ca3c1dd.svg";
export { ForwardRef as ReactComponent };